import { Divider, Select } from "antd";
import React, { useEffect, useState } from "react";
import Sales from "../Dashboard/Sales";
import moment from "moment/moment";
import { get } from "../../apiService";
import StaffSales from "../Dashboard/StaffSales";
import CitySales from "../Dashboard/CitySales";
import CountrySales from "../Dashboard/CountrySales";

export default function Dashboard() {
  const [sales, setSales] = useState([]);
  const [staffSales, setStaffSales] = useState([]);
  const [selected, setSelected] = useState("Daily");
  const startDate = moment().subtract(6, "days"); // For daily range: 6 days ago
  const endDate = moment(); // Today's date for daily range
  const [datesInRange, setDatesInRange] = useState([]);
  const [citySales, setCitySales] = useState([]);
  const [countrySales, setCountrySales] = useState([]);



  const fetchArrayList = (selected) => {
    const rangeList = [];

    switch (selected) {
      case "Daily":
        let tempDate = startDate.clone();
        while (tempDate.isSameOrBefore(endDate)) {
          rangeList.push(tempDate.format("DD MMM"));
          tempDate.add(1, "days");
        }
        break;

      case "Monthly":
        for (let i = 0; i < 12; i++) {
          // Calculate the month, going backward from the current month
          const month = moment().subtract(i, "months").format("MMM YY");
          rangeList.push(month);
        }
        rangeList.reverse();
        break;

      case "Yearly":
        for (let yearOffset = 0; yearOffset < 7; yearOffset++) {
          rangeList.push(moment().subtract(yearOffset, "years").format("YYYY"));
        }
        rangeList.reverse();
        break;

      default:
        console.error("Invalid selection");
    }
    setDatesInRange(rangeList);
  };

  const getAnalytics = async (type) => {
    try {
      let newData = null;
      if (type === "Daily") {
        newData = `startDate=${moment(startDate).format(
          "YYYY-MM-DD"
        )}&endDate=${moment(endDate).format("YYYY-MM-DD")}`;
      }
      const resp = await get(
        `/dashboard.php?dateType=${type}${newData ? "&" + newData : ""}`
      );

      if (resp) {
        const newDales = resp?.sales?.online.map((val) => {
          const matchingOffline = resp?.sales?.offline.find(
            (newVal) => val.date === newVal.date
          );
          return {
            date:
              type === "Daily"
                ? moment(val.date).format("DD MMM")
                : type === "Monthly"
                ? moment(val.date).format("MMM YY")
                : moment(val.date).format("YYYY"),
            online: parseInt(val.value),
            offline: parseInt(matchingOffline ? matchingOffline.value : 0),
          };
        });
        if (type !== "Daily") {
          newDales.splice(0, 1);
        }
        setSales([...newDales]);

        const stafSalesData = resp?.staff_sales.map((val) => ({
          ...val,
          date:
            type === "Daily"
              ? moment(val.date).format("DD MMM")
              : type === "Monthly"
              ? moment(val.date).format("MMM YY")
              : moment(val.date).format("YYYY"),
        }));
        setStaffSales(stafSalesData);

        const citySalesData = resp?.city.map((val) => ({
          ...val,
          date:
            type === "Daily"
              ? moment(val.date).format("DD MMM")
              : type === "Monthly"
              ? moment(val.date).format("MMM YY")
              : moment(val.date).format("YYYY"),
        }));

        setCitySales(citySalesData);

        const countrySalesData = resp?.country.map((val) => ({
          ...val,
          date:
            type === "Daily"
              ? moment(val.date).format("DD MMM")
              : type === "Monthly"
              ? moment(val.date).format("MMM YY")
              : moment(val.date).format("YYYY"),
        }));

        setCountrySales(countrySalesData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchArrayList(selected);
      getAnalytics(selected);
    }, 300);

    return () => clearTimeout(dbounce);
  }, [selected]);

  return (
    <div>
      <div className="container">
        <div className="dashboardDetail">
          <div className="dashboardHeader d-flex align-items-center justify-content-between">
            <h3>Sales Analytics</h3>
            <div className="rightSide">
              <Select
                value={selected}
                style={{ width: "100px", marginRight: "10px" }}
                onChange={setSelected}
                options={[
                  { label: "Daily", value: "Daily" },
                  { label: "Monthly", value: "Monthly" },
                  { label: "Yearly", value: "Yearly" },
                ]}
              />
            </div>
          </div>
          <div className="dashboardBody">
            <div className="row">
              <h5>Total Sales</h5>
              <Sales datesInRange={datesInRange} sales={sales} />
              <Divider />
              <h5>Staff Sales</h5>
              <StaffSales
                datesInRange={datesInRange}
                staffSalesData={staffSales}
              />
              <Divider />
              <h5>City Sales</h5>
              <CitySales
                datesInRange={datesInRange}
                staffSalesData={citySales}
              />
              <Divider />
              <h5>Country Sales</h5>
              <Divider />
              <CountrySales
                datesInRange={datesInRange}
                staffSalesData={countrySales}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
